import React from 'react';
import { useIntl } from 'react-intl';
import { NavLink } from 'react-router';
import {
  Col, Icons, Row,
} from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { Dialog, DialogContent, DialogTitle } from '../../../components/base/Dialog/Dialog';
import {
  dateFormatter, dateTimeFormatter, localeFormatter, registryLinkFormatter, statusFormatter,
} from '../../../utils/formatters';
import {
  APPLICATION_SUBJECT_TYPES, CHECK_STATUS_NAMES, REGISTRY_TYPE, SUBJECT_TYPE,
} from '../../../configs';

export default function CheckTypesView({ close = () => {}, current = {} }) {
  const { formatMessage } = useIntl();
  const {
    procedures = [],
    type = null,
    id = null,
    status = 1,
    subject_type = null,
    subject_id = null,
    subject = null,
  } = current;
  return (
    <Dialog
      className="check-types-view-dialog"
      onClose={close}
      open
    >
      <DialogTitle header="Просмотр запроса" title={<Icons onClick={close} customIcon icon="close" className="close" />} />
      <DialogContent className="check-types-view-content">
        <div className="check-types-view-table">
          <Row className="row-cols-2">
            <Col className="check-types-view-label" columns={4}>Идентификатор обращения</Col>
            <Col className="check-types-view-value" columns={8}>{id || ''}</Col>
          </Row>
          <Row className="row-cols-2">
            <Col className="check-types-view-label" columns={4}>Запрашиваемая информация</Col>
            <Col className="check-types-view-value" columns={8}>{type && type.name ? type.name : ''}</Col>
          </Row>
          <Row className="row-cols-2">
            <Col className="check-types-view-label" columns={4}>Дата запроса</Col>
            <Col className="check-types-view-value" columns={8}>{dateTimeFormatter(current.created_at)}</Col>
          </Row>
          <Row className="row-cols-2">
            <Col className="check-types-view-label" columns={4}>Дата получения ответа</Col>
            <Col className="check-types-view-value" columns={8}>{dateTimeFormatter(current.responded_at)}</Col>
          </Row>
          <Row className="row-cols-2">
            <Col className="check-types-view-label" columns={4}>Тип субъекта</Col>
            <Col className="check-types-view-value" columns={8}>{localeFormatter('subject.type', subject_type)}</Col>
          </Row>
          <Row className="row-cols-2">
            <Col className="check-types-view-label" columns={4}>Связь с обращением или реестровой записью</Col>
            <Col className="check-types-view-value" columns={8}>
              {APPLICATION_SUBJECT_TYPES.includes(subject_type) ? <NavLink to={`/application?application_id=${subject_id}`}>{subject && subject.procedure_label ? subject.procedure_label : subject_id}</NavLink> : null}
              {subject_type === SUBJECT_TYPE.CARRIER ? registryLinkFormatter(subject && subject.number ? subject.number : subject_id, REGISTRY_TYPE.CARRIER, { registry_id: subject_id }) : null}
              {subject_type === SUBJECT_TYPE.ORDER_SERVICE ? registryLinkFormatter(subject && subject.number ? subject.number : subject_id, REGISTRY_TYPE.ORDER_SERVICE, { registry_id: subject_id }) : null}
              {subject_type === SUBJECT_TYPE.VEHICLE ? registryLinkFormatter(subject && subject.number ? subject.number : subject_id, REGISTRY_TYPE.VEHICLE, { registry_id: subject_id }) : null}
            </Col>
          </Row>
          <Row className="row-cols-2">
            <Col className="check-types-view-label" columns={4}>Статус</Col>
            <Col className="check-types-view-value" columns={8}>{statusFormatter(status, 'check.status', CHECK_STATUS_NAMES)}</Col>
          </Row>
          <Row className="row-cols-2">
            <Col className="check-types-view-label" columns={4}>Дата ответа</Col>
            <Col className="check-types-view-value" columns={8}>{dateTimeFormatter(current.responded_at)}</Col>
          </Row>
        </div>
      </DialogContent>
    </Dialog>
  );
}
